<template>
  <v-dialog
      v-model="dialog"
      max-width="896"
      persistent
  >
    <v-card>
      <v-card-title class="headline">Registrar usuario</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-5">
        <v-form ref="formCreateUser">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="newUser.name"
                  label="Nombre *"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.counter]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="newUser.lastname1"
                  label="Apellido paterno *"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.counter]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                  v-model="newUser.lastname2"
                  label="Apellido materno"
                  outlined
                  dense
                  :rules="[rules.counter]"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="newUser.phone"
                  label="Teléfono *"
                  outlined
                  dense
                  required
                  type="text"
                  :rules="[rules.required, rules.phone]"
                  counter
                  maxlength="12"
                  @input="formatPhone"
                  prepend-inner-icon="mdi-phone-outline"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                  v-model="newUser.email"
                  label="Correo electrónico *"
                  outlined
                  dense
                  required
                  type="email"
                  :rules="[rules.required, rules.email]"
                  prepend-inner-icon="mdi-email-outline"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                  v-model="newUser.username"
                  label="Nombre de usuario *"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.username]"
                  prepend-inner-icon="mdi-account-outline"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" md="7">
              <v-text-field
                  v-model="newUser.password"
                  label="Contraseña *"
                  outlined
                  dense
                  required
                  :type="showPassword ? 'text' : 'password'"
                  :rules="[rules.required, rules.password]"
                  hint="La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un símbolo"
                  prepend-inner-icon="mdi-lock-outline"
              >
                <template v-slot:append>
                  <v-icon @click="showPassword = !showPassword" :color="showPassword ? 'primary' : ''">
                    {{ !showPassword ? 'mdi-eye-off' : 'mdi-eye' }}
                  </v-icon>
                </template>
                <template v-slot:append-outer>
                  <v-btn
                      x-small
                      shaped
                      color="green"
                      text
                      @click="newUser.password = generatePassword()" :disabled="isLoading"
                  >
                    <v-icon left color="green">
                      mdi-dice-5
                    </v-icon>
                    Aleatoria
                  </v-btn>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-select
                  v-model="newUser.role"
                  :items="roles"
                  label="Rol *"
                  outlined
                  dense
                  required
                  :rules="[rules.required]"
                  prepend-inner-icon="mdi-account-cog-outline"
              >
              </v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
              <v-menu
                  v-model="birthdateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formattedBirthdate"
                      label="Fecha de nacimiento *"
                      prepend-inner-icon="mdi-calendar-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      required
                      :rules="[rules.required]"
                      :hint="currentAgeDisplay"
                      persistent-hint
                  />
                </template>
                <v-date-picker
                    v-model="newUser.birthdate"
                    first-day-of-week="1"
                    locale="es-MX"
                    :active-picker.sync="birthdateActivePicker"
                    :max="new Date(Date.now() - 1000 * 60 * 60 * 24 * 365 * 18).toISOString().substr(0, 10)"
                    :min="new Date(Date.now() - 1000 * 60 * 60 * 24 * 365 * 100).toISOString().substr(0, 10)"
                    @change="saveBirthdate"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="6" v-if="newUser.role === 'DIETICIAN'">
              <v-menu
                  v-model="renovationDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="formattedRenovationDate"
                      label="Fecha de renovación *"
                      prepend-inner-icon="mdi-calendar-clock-outline"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      required
                      :rules="[rules.required]"
                  />
                </template>
                <v-date-picker
                    v-model="newUser.renovationDate"
                    locale="es-MX"
                    :active-picker.sync="renovationDateActivePicker"
                    @change="saveRenovationDate"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <CancelButton
            :isDisabled="isLoading"
            @click="handleDialogClose"
        />
        <CreateButton
            :isLoading="isLoading"
            :isDisabled="!isValidForm()"
            @click="createUser"
            label="Registrar usuario"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

import UserService from "@/services/users/UserService";
import throwErrorMessage from "@/utils/ErrorMessage";
import throwSuccessMessage from "@/utils/SuccessMessage";
import CancelButton from "@/components/buttons/CancelButton.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";

export default Vue.extend({
  name: "ModalCreateUser",
  components: {CreateButton, CancelButton},
  data() {
    return {

      // Loading
      isLoading: false,

      // Dialog
      dialog: false,

      // Birthdate
      birthdateMenu: false,
      birthdateActivePicker: 'YEAR' as 'YEAR' | 'MONTH' | 'DATE',

      // Renovation date
      renovationDateMenu: false,
      renovationDateActivePicker: 'DATE' as 'YEAR' | 'MONTH' | 'DATE',

      // Validation
      rules: {
        required: (value: string) => !!value || 'Campo requerido',
        counter: (value: string) => (value || '').length <= 50 || 'Máximo 50 caracteres',
        email: (value: string) => {
          if (!value) return true;
          const pattern = /^[a-zA-Z0-9ñÑ._%+-]+@[a-zA-Z0-9ñÑ.-]+.[a-zA-ZñÑ]{2,}$/;
          return pattern.test(value) || 'Correo electrónico inválido';
        },
        phone: (value: string) => {
          const pattern = /^\d{3}-\d{3}-\d{4}$/;
          return pattern.test(value) || 'Teléfono inválido';
        },
        password: (value: string) => {
          const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[a-zA-Z\d\W_]{8,}$/;
          return pattern.test(value) || 'La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un símbolo';
        },
        username: (value: string) => {
          const pattern = /^[a-zA-Z0-9]{4,20}$/;
          return pattern.test(value) || 'El nombre de usuario debe tener entre 4 y 20 caracteres alfanuméricos';
        },
      },

      // User
      newUser: {
        name: "",
        lastname1: "",
        lastname2: "",
        phone: "",
        email: "",
        birthdate: "",
        username: "",
        password: "",
        role: "",
        renovationDate: "",
      },
      showPassword: false,

      // Roles
      roles: [
        {text: "Administrador", value: "ADMIN"},
        {text: "Dietista", value: "DIETICIAN"},
      ],
    };
  },

  watch: {
    birthdateMenu(val) {
      val && setTimeout(() => (this.birthdateActivePicker = 'YEAR'))
    },
    renovationDateMenu(val) {
      val && setTimeout(() => (this.renovationDateActivePicker = 'DATE'))
    },
  },

  computed: {
    formattedBirthdate(): string | null {
      if (!this.newUser.birthdate) return null;
      const [year, month, day] = this.newUser.birthdate.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      return new Intl.DateTimeFormat('es-MX', options).format(date);
    },
    formattedRenovationDate(): string | null {
      if (!this.newUser.renovationDate) return null;
      const [year, month, day] = this.newUser.renovationDate.split('-').map(Number);
      const date = new Date(year, month - 1, day);
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      };
      return new Intl.DateTimeFormat('es-MX', options).format(date);
    },
    currentAgeDisplay(): string | null {
      if (!this.newUser.birthdate) return null;
      const birthDate = new Date(this.newUser.birthdate);
      const today = new Date();

      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();

      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }

      return `${age} años`;
    },
  },

  methods: {
    handleDialogClose() {
      const form = this.$refs.formCreateUser as any;
      form.resetValidation();
      form.reset();
      this.dialog = false;
    },

    saveBirthdate() {
      this.birthdateMenu = false;
    },

    saveRenovationDate() {
      this.renovationDateMenu = false;
    },

    isValidForm() {
      if (!this.newUser.name ||
          !this.newUser.username ||
          !this.newUser.password ||
          !this.newUser.lastname1 ||
          !this.newUser.phone ||
          !this.newUser.role ||
          !this.newUser.email ||
          !this.newUser.birthdate) {
        return false;
      }

      if (this.newUser.role === "DIETICIAN" && !this.newUser.renovationDate) {
        return false;
      }

      if (this.newUser.role === "ADMIN") {
        this.newUser.renovationDate = "";
      }

      return true;
    },

    generatePassword() {
      const length = 8;
      const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const lowercase = "abcdefghijklmnopqrstuvwxyz";
      const numbers = "0123456789";
      const symbols = "!@#$%&*_+?.";
      const allCharacters = uppercase + lowercase + numbers + symbols;
      let password = "";

      password += uppercase[Math.floor(Math.random() * uppercase.length)];
      password += lowercase[Math.floor(Math.random() * lowercase.length)];
      password += numbers[Math.floor(Math.random() * numbers.length)];
      password += symbols[Math.floor(Math.random() * symbols.length)];

      for (let i = password.length; i < length; i++) {
        password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
      }

      return password.split("").sort(() => Math.random() - 0.5).join("");
    },

    async createUser() {
      const form = this.$refs.formCreateUser as any;
      if (form.validate()) {
        try {
          this.isLoading = true;
          await UserService.createUser(this.newUser);
          throwSuccessMessage("Usuario registrado correctamente");
          this.$emit("created");
          this.handleDialogClose();
        } finally {
          this.isLoading = false;
        }
      } else {
        throwErrorMessage("Asegúrate de llenar todos los campos correctamente");
      }
    },

    formatPhone(value: string) {
      if (!value) return;
      if (!this.newUser) return;
      let digits = value.replace(/\D/g, '');

      if (digits.length > 10) {
        digits = digits.substring(0, 10);
      }

      if (digits.length > 6) {
        this.newUser.phone = digits.replace(/(\d{3})(\d{3})(\d{0,4})/, '$1-$2-$3');
      } else if (digits.length > 3) {
        this.newUser.phone = digits.replace(/(\d{3})(\d{0,3})/, '$1-$2');
      } else {
        this.newUser.phone = digits;
      }
    },
  },
});
</script>

<style scoped>

</style>
